import React, { useState } from "react";
import { api } from "../../utils/Api";
import UserSkills from "../../components/UserSkills/UserSkills";
import AddWorkExperience from "../../components/AddWorkExperience/AddWorkExperience";
import Header from "../../components/Header/Header";
import "../../assets/css/style.css";

export default function CreateAccount() {
  const [create_ac_data, SetCreateAcData] = useState({
    about: {
      show: true,
      data: {
        title: "",
        summary: "",
        price: "",
      },
    },
    skill: {
      show: false,
      data: [],
    },
    work_xp: {
      show: false,
      data: [],
    },
  });

  const about_view = (key: any, key_index: any) => {
    return (
      <div className="container pt-3">
        <div className="card p-3">
          <div>
            <h3>SignUp</h3>
          </div>
          <form
            className="px-3"
            onSubmit={(e) => {
              e.preventDefault();
              console.log("about view on submit");
              save_about(key, key_index);
            }}
          >
            <div className="mb-3 mt-2">
              <label for="exampleFormControlInput1" class="form-label">
                Title
              </label>
              <input
                type="text"
                value={create_ac_data[key].data.title}
                className="form-control"
                id="exampleFormControlInput1"
                placeholder="Title"
                aria-label="default input example"
                onChange={(e) => {
                  SetCreateAcData((prevValue: any) => {
                    console.log("on change title :", e.target.value);

                    prevValue[key].data.title = e.target.value;
                    return { ...prevValue };
                  });
                }}
              />
            </div>

            <div className="mb-3">
              <label for="exampleFormControlInput1" class="form-label">
                Summary
              </label>
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                value={create_ac_data[key].data.summary}
                placeholder="Summary"
                onChange={(e) => {
                  SetCreateAcData((prevValue: any) => {
                    prevValue[key].data.summary = e.target.value;
                    return { ...prevValue };
                  });
                }}
              />
            </div>

            <div className="col-md-4 mb-3">
              <label for="validationCustomUsername" class="form-label">
                Hourly Price
              </label>
              <div className="input-group has-validation">
                <span className="input-group-text" id="inputGroupPrepend">
                  ₹
                </span>
                <input
                  className="form-control"
                  id="validationCustomUsername"
                  aria-describedby="inputGroupPrepend"
                  type="number"
                  value={create_ac_data[key].data.price}
                  placeholder="Price"
                  onChange={(e) => {
                    SetCreateAcData((prevValue: any) => {
                      prevValue[key].data.price = e.target.value;
                      return { ...prevValue };
                    });
                  }}
                />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button type="submit" className="btn btn-primary px-3">
                Next <i className="fas fa-angle-right"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  async function save_about(key: any, key_index: any) {
    console.log("save_about");
    let pass_data = {
      post: {
        title: create_ac_data[key].data.title,
        description: create_ac_data[key].data.summary,
        hourly_price: create_ac_data[key].data.price,
      },
    };
    console.log("passdata :", pass_data);
    let response: any = await api("/users/signup", pass_data);
    console.log(response.status_code);
    console.log("response :", response);
    if (response.status_code == 200) {
      SetCreateAcData((prevValue: any) => {
        prevValue[key].show = false;
        let next_index_value = parseInt(key_index) + 1;
        Object.keys(prevValue).map((c_key: any, c_key_index: any) => {
          if (next_index_value == c_key_index) {
            prevValue[c_key].show = true;
          }
        });
        return { ...prevValue };
      });
    }
  }

  function skill_on_next(data: any, key: any, key_index: any) {
    console.log("skill_on_next :", data);
    SetCreateAcData((prevValue: any) => {
      prevValue[key].show = false;
      prevValue[key].data = data;

      let next_index_value = parseInt(key_index) + 1;
      Object.keys(prevValue).map((c_key: any, c_key_index: any) => {
        if (next_index_value == c_key_index) {
          prevValue[c_key].show = true;
        }
      });
      return { ...prevValue };
    });
  }

  function work_xp_on_next(data: any, key: any, key_index: any) {}

  function work_xp_on_back(data: any, key: any, key_index: any) {
    SetCreateAcData((prevValue: any) => {
      prevValue[key].show = false;
      prevValue[key].data = data;

      let prev_index_value = parseInt(key_index) - 1;
      Object.keys(prevValue).map((c_key: any, c_key_index: any) => {
        if (prev_index_value == c_key_index) {
          prevValue[c_key].show = true;
        }
      });
      return { ...prevValue };
    });
  }

  return (
    <div>
      {/* <Header /> */}
      <div className="container mb-3">
        <div className="row justify-content-center">
          <div className="col-lg-2 pt-3">
            {Object.keys(create_ac_data).map((key: any, key_index: any) => (
              <div key={key_index}>
                <button
                  type="button"
                  className="btn text-dark mb-2"
                  onClick={() => {
                    if (key != "about") {
                      SetCreateAcData((prevValue: any) => {
                        // prevValue[key].show = !prevValue[key].show;
                        Object.keys(prevValue).map(
                          (pre_key: any, pre_key_index: any) => {
                            if (key == pre_key) {
                              prevValue[pre_key].show = true;
                            } else {
                              prevValue[pre_key].show = false;
                            }
                          }
                        );
                        return { ...prevValue };
                      });
                    }
                  }}
                >
                  {key == "about" ? (
                    <div
                      className={
                        create_ac_data[key].show
                          ? "d-flex  fw-bold text-primary"
                          : "d-flex   text-muted"
                      }
                    >
                      <div style={{ width: "27px" }}>
                        <i className="fas fa-info"></i>
                      </div>
                      About
                    </div>
                  ) : null}
                  {key == "skill" ? (
                    <div
                      className={
                        create_ac_data[key].show
                          ? "d-flex  fw-bold text-primary "
                          : "d-flex   text-muted"
                      }
                    >
                      <div style={{ width: "27px" }}>
                        <i className="fas fa-brain"></i>
                      </div>
                      Skills
                    </div>
                  ) : null}
                  {key == "work_xp" ? (
                    <div
                      className={
                        create_ac_data[key].show
                          ? "d-flex  fw-bold text-primary "
                          : "d-flex   text-muted"
                      }
                    >
                      <div style={{ width: "27px" }}>
                        <i className="fas fa-briefcase"></i>
                      </div>
                      Work Experience
                    </div>
                  ) : null}
                </button>
              </div>
            ))}
          </div>
          <div className="col-lg-7">
            {Object.keys(create_ac_data).map(
              (key: any, key_index: any) =>
                create_ac_data[key].show && (
                  <div key={key_index}>
                    {key == "about" ? about_view(key, key_index) : null}
                    {key == "skill" ? (
                      <UserSkills
                        from={"create_account"}
                        on_next={(data: any) => {
                          skill_on_next(data, key, key_index);
                        }}
                      />
                    ) : null}
                    {key == "work_xp" ? (
                      <AddWorkExperience
                        from={"create_account"}
                        on_next={(data: any) => {
                          work_xp_on_next(data, key, key_index);
                        }}
                        on_back={(data: any) => {
                          work_xp_on_back(data, key, key_index);
                        }}
                      />
                    ) : null}
                  </div>
                )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
